module.exports = __webpack_public_path__ + "img/metro_L5.1e711713.svg";